import factory from './icon';
import Svg from './glyphs/pn_logo.svg';

export default factory(Svg);
